export default "__VITE_ASSET__CWZ_p6X4__"